/* Sns Service Module */
import { SIGNIN_001 } from '@/features/Auth/error';
import { SNS_002, SNS_007 } from '../error';
import { SNS_TYPE_ENUM, SnsConnectControllerReqBody } from '../schema';
import type { SnsType, SnsUserDataType } from '../type';

export const validateSnsConnectReqBody = (body: Record<string, any>) => {
  const parse_body = SnsConnectControllerReqBody.safeParse(body);

  if (!parse_body.success) {
    throw SIGNIN_001(parse_body.error);
  }

  return parse_body.data;
};
export const validateSnsType = (_sns_type: SnsType) => {
  const sns_type = SNS_TYPE_ENUM.safeParse(_sns_type);

  if (sns_type.error) {
    throw SNS_007(sns_type.error, _sns_type);
  }

  return sns_type.data;
};

export const validateSessionUserSnsData = (user_sns: SnsUserDataType | undefined) => {
  if (!user_sns) {
    throw SNS_002();
  }

  return user_sns;
};
